import { Field } from "sparkson";

export class PlayerControls {
  logoUrl?: string;
  constructor(
    @Field("l", true) public logo?: string,
    @Field("lv", true) public logoVisiblePermanently: boolean = true,
    @Field("se", true) public seekbarEnabled: boolean = true,
    @Field("ce", true) public controlbarEnabled: boolean = true,
    @Field("pe", true) public playPauseEnabled: boolean = true,
    @Field("fe", true) public fullscreenEnabled: boolean = true,
    @Field("soe", true) public socialButtonEnabled: boolean = true,
    @Field("piop", true) public playIconOnPoster: boolean = false,
  ) {}
}
